import { FilteredListResult } from "./types";
import { useEffect, useRef } from "react";
import { useLazySearchFilteredEventsQuery } from "@app/data/events/eventsApi";
import useFeedPaginationState from "../useFeedPagination";
import useEventFilter from "../../../filter/hooks/useEventFilter";
import { ioErrorOf } from "@app/data/errors";
import { useAppSelector } from "@app/hooks";
import { selectFilter } from "../../../filter/selectors";

const useFeedEventsFilteredList = (): FilteredListResult => {
  const { currentFilter } = useEventFilter()
  const filter = useAppSelector(selectFilter)
  const [lazyQuery, { isLoading, error, data }] = useLazySearchFilteredEventsQuery()
  const { page, size } = useFeedPaginationState()

  // Лента пуста только когда «Все» выключена И ни одна категория не выбрана.
  // Это явное состояние: в ленте показывается подсказка (см. feed_page).
  const hasCategory = Array.isArray(filter.eventTypeId) && filter.eventTypeId.length > 0
  // Лента грузится всегда: без категории — все события, с датой — по дате, и т.д.
  const shouldFetch = true

  const prevShouldFetch = useRef(shouldFetch)
  const { setPage } = useFeedPaginationState()

  // При любой смене фильтра (категория, город, дата, «0 ₽») возвращаемся на первую страницу.
  // Иначе с 3-й страницы ленты клик по категории запрашивал 3-ю страницу категории — пусто.
  // Строим ключ из полей фильтра, которые реально уйдут на бэкенд.
  // Пропускаем undefined, null, пустые строки и массивы длиной 0.
  const filterKey = JSON.stringify(currentFilter, (_, v) => {
    if (v === undefined || v === null) return "__EMPTY__"
    if (Array.isArray(v) && v.length === 0) return "__EMPTY__"
    if (v === "") return "__EMPTY__"
    return v
  })
  const prevFilterKey = useRef(filterKey)

  useEffect(() => {
    if (!shouldFetch) return
    if (prevFilterKey.current !== filterKey) {
      prevFilterKey.current = filterKey
      if (page !== 0) { setPage(0); return }
    }
    lazyQuery({ page, size, filter: currentFilter })
    prevShouldFetch.current = shouldFetch
  }, [filterKey, page, shouldFetch])

  return {
    isLoading,
    error: ioErrorOf(error),
    filteredList: data?.content,
    isEmpty: data?.metadata.totalElements === 0,
    pagination: data?.metadata && data.metadata
  }
}
export default useFeedEventsFilteredList
